/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React, {CSSProperties} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import PageMonitorComplete, {
  isAPMEnabled
} from '@ion/telemetry/src/apm/automation/PageMonitorComplete';
import ConditionalRender from '../../render/ConditionalRender';

export interface RenderFrameType {
  url: string;
  style?: CSSProperties;
  scrolling?: 'auto' | 'yes' | 'no';
};

const useStyles = makeStyles(theme => ({
  frame : {
    width  : '100%',
    height : '100%'
  }
}));

/**
 * @RenderFrame
 * Component for rendering iFrames
 *
 * @param {string} url: the iframe url
 *
 * ```typescript
 *
 * import {RenderFrame} from '@ion/dls/src/components/frame/RenderFrame';
 *
 * <RenderFrame url='https://google.com' />
 *
 * ```
 */
export const RenderFrame = ({url, style, scrolling = 'no'}: RenderFrameType) => {
  const classes = useStyles();
  return (
    <>
      <iframe name='rendered-frame' src={url} scrolling={scrolling} className={classes.frame} style={style} />
      <ConditionalRender condition={isAPMEnabled}>
        <PageMonitorComplete autoComplete />
      </ConditionalRender>
    </>
  );
};

export default RenderFrame;
